/* Module + lesson catalog — generated by sales-academy-factory from the Academy
 * spec. Drives the dashboard learning path and lesson routing. Module 1 Lesson 4
 * is the seeded interactive lesson (see lessons.ts). */
export interface LessonMeta {
  lesson_id: string;
  lesson: number;
  title: string;
}

export interface ModuleMeta {
  module: number;
  title: string;
  lessons: LessonMeta[];
  /** "locked" until the previous module is complete. M1 always unlocked. */
  unlocks_after_module?: number;
}

export const MODULES_SEED: ModuleMeta[] = [
  {
    module: 1,
    title: "Anchoring Price Expectations in Comparable Sales Data",
    lessons: [
      { lesson_id: "m1-l1-why-buyers-and-sellers-default-to-wishfu", lesson: 1, title: "Why Buyers and Sellers Default to Wishful Pricing" },
      { lesson_id: "m1-l2-reading-a-cma-the-numbers-that-actually-", lesson: 2, title: "Reading a CMA: The Numbers That Actually Matter" },
      { lesson_id: "m1-l3-presenting-comps-without-overwhelming-yo", lesson: 3, title: "Presenting Comps Without Overwhelming Your Client" },
      { lesson_id: "m1-l4-anchoring-price-expectations-with-dan-ko", lesson: 4, title: "Anchoring Price Expectations with Dan Kowalski: Skeptical Price Shopper" },
      { lesson_id: "m1-l5-defending-your-price-position-when-clien", lesson: 5, title: "Defending Your Price Position When Clients Push Back" },
    ],
  },
  {
    module: 2,
    title: "Needs Assessment: Budget, Timeline, Neighborhood, and Long-Term Goals",
    unlocks_after_module: 1,
    lessons: [
      { lesson_id: "m2-l1-the-four-pillars-of-a-real-estate-needs-", lesson: 1, title: "The Four Pillars of a Real Estate Needs Assessment" },
      { lesson_id: "m2-l2-uncovering-hidden-budget-constraints-wit", lesson: 2, title: "Uncovering Hidden Budget Constraints with Tyler Brandt: First-Time Buyer" },
      { lesson_id: "m2-l3-reading-between-the-lines-timeline-press", lesson: 3, title: "Reading Between the Lines: Timeline Pressure and Life Events" },
      { lesson_id: "m2-l4-aligning-neighborhood-wants-with-long-te", lesson: 4, title: "Aligning Neighborhood Wants with Long-Term Goals" },
    ],
  },
  {
    module: 3,
    title: "Regulatory Transparency: Agency Disclosure and Commission Structure",
    unlocks_after_module: 2,
    lessons: [

    ],
  },
  {
    module: 4,
    title: "Fair Housing Compliance and Anti-Steering Practice",
    unlocks_after_module: 3,
    lessons: [

    ],
  },
  {
    module: 5,
    title: "Material Fact Disclosure, Ethical Urgency, and HOA Obligations",
    unlocks_after_module: 4,
    lessons: [

    ],
  },
];

export const TOTAL_MODULES = MODULES_SEED.length;

export function findModule(moduleNum: number): ModuleMeta | undefined {
  return MODULES_SEED.find((m) => m.module === moduleNum);
}

export function findLesson(moduleNum: number, lessonNum: number): LessonMeta | undefined {
  return findModule(moduleNum)?.lessons.find((l) => l.lesson === lessonNum);
}
